module.exports = __webpack_public_path__ + "img/framenew_box10.1e018414.jpg";